/**
 * Panonun ortak tema ve renk sözlüğü — dört sekme de buradan beslenir.
 *
 * Plastik projesindeki (`bshplasticfrontend`) pano ile BİREBİR aynı değerler:
 * iki fabrikanın panosu yan yana konduğunda aynı ürün gibi görünsün diye
 * palet, zemin ve çerçeve renkleri ortak tutuluyor.
 */
export const DASHBOARD_THEME = {
  palette: ["#e8a33d", "#3b9bf5", "#1e40d6", "#b3a0e0", "#f0682b", "#10b981"],
  surface: "#1c1c1c",
  border: "#3d3d3d",
  grid: "#3a3a3a",
  axis: "#c9c9c9",
  text: "#f3f4f6",
  muted: "#b8b8b8",
  label: "#f3f4f6",
  accent: "#e8b52e",
  accentText: "#1a1a1a",
  tooltipBg: "#2b2b2b",
  tooltipBorder: "#4a4a4a",
  locale: "tr-TR",
};

/** Grafik renkleri — Power BI raporundaki paletle birebir. */
export const AMBER = "#e8a33d";
export const BLUE = "#3b9bf5";
export const ORANGE = "#f0682b";
export const PURPLE = "#b3a0e0";
/** "Single Gövde Üretim" çubukları — rapordaki mercan/kırmızı ton. */
export const CORAL = "#e35f6e";
/** "U Gövde Stok" çizgisi rapordaki gibi beyaz. */
export const WHITE = "#f5f5f5";
/** Renk pastasındaki Silver dilimi — gri, beyaz dilimden ayrışsın diye. */
export const SILVER = "#9aa0a6";

/** Pano arka planı (tuvalin zemini). */
export const CANVAS_BG = "#000000";
